import { createSlice } from "@reduxjs/toolkit";
import * as Actions from "../actions";
import { dataApelidosReducer } from "../reducers";
import { InitialStateApelidos } from "../models/apelidos.model";

const initialState: InitialStateApelidos = {
  items: [],
  dialogForm: {
    open: false,
    content: {
      mode: "",
      values: null,
    },
  },
  requestGetParams: {},
  pagination: {
    page: 1,
    rowsPerPage: 15,
    totalPages: 0,
    totalItems: 0,
  },
};

const apelidosSlice = createSlice({
  name: "transportadorasApp/apelidos",
  initialState,
  reducers: {
    openDialogForm: (state, action) => {
      state.dialogForm = {
        open: true,
        content: action.payload,
      };
    },
    closeDialogForm: (state) => {
      state.dialogForm = {
        open: false,
        content: {
          mode: "",
          values: null,
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(Actions.getApelidos.fulfilled, dataApelidosReducer);
  },
});

export const { openDialogForm, closeDialogForm } = apelidosSlice.actions;

export default apelidosSlice.reducer;
